import { render, staticRenderFns } from "./AccountEdit.vue?vue&type=template&id=44ef10fa&"
import script from "./AccountEdit.vue?vue&type=script&lang=js&"
export * from "./AccountEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports